import { UtilisationPeriod } from '../../../back-end/common/billyDashboard'

export const utilisationPeriod = ['week', 'month', 'year'] as const

export const isUtilisationPeriod = (utilPeriod: string): utilPeriod is UtilisationPeriod => utilisationPeriod.includes(utilPeriod as UtilisationPeriod)
